import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AbstractFilterMenuComponent } from '@connect-services/client/components/abstract-filter-menu/abstract-filter-menu.component';
import { EntityStatusFilterOptionsComponent } from '@connect-services/client/components/entity-status-filter-options/entity-status-filter-options.component';
import { FilterMenuSkeletonComponent } from '@connect-services/client/components/filter-menu/filter-menu-content/filter-menu-skeleton.component';
import { FormFilterOptionsComponent } from '@connect-services/client/components/form-filter-options/form-filter-options.component';
import { OperatorsFilterOptionsComponent } from '@connect-services/client/components/operators-filter-options/operators-filter-options.component';
import { CheckboxState } from '@connect-services/client/lib/components/checkbox/checkbox.component';
import { FieldInterventionEntity } from '@connect-services/client/sdk/api';
import { EntitiesTableByLayerService } from '@connect-services/client/services/entities-table-by-layer.service';
import { FieldInterventionEntitiesFilterService } from '@connect-services/client/services/field-intervention-entities-filter.service';
import { ButtonType } from '@connect-services/src/lib/components/button/button.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EntityStatusFilterOptionsComponent,
        FilterMenuSkeletonComponent,
        FormFilterOptionsComponent,
        OperatorsFilterOptionsComponent,
    ],
    selector: 'app-field-intervention-entities-filter',
    styleUrl: './field-intervention-entities-filter.component.scss',
    templateUrl: './field-intervention-entities-filter.component.html',
})
export class FieldInterventionEntitiesFilterComponent extends AbstractFilterMenuComponent {
    protected readonly ButtonType = ButtonType;
    protected readonly CheckboxState = CheckboxState;
    protected readonly FieldInterventionEntityStatusEnum = FieldInterventionEntity.StatusEnum;
    protected readonly filterEntitiesTableService = inject(FieldInterventionEntitiesFilterService);

    private readonly entitiesTableByLayerService = inject(EntitiesTableByLayerService);

    public constructor() {
        super();
        this.filterEntitiesTableService.initData();
        if (this.filterEntitiesTableService.filterByParams()) {
            this.filterEntitiesTableService.baseFilterParams.set(this.filterEntitiesTableService.filterByParams());
        }
    }

    public override resetData(): void {
        this.filterEntitiesTableService.resetData();
    }

    public resetSelection(): void {
        this.filterEntitiesTableService.resetCheckboxState();
    }

    public async submit(): Promise<void> {
        this.filterEntitiesTableService.submitFilter();
        await this.entitiesTableByLayerService.fetchEntities();

        this.closeMenu();
    }

    private closeMenu(): void {
        this.filterEntitiesTableService.closeFilterMenu();
        this.closeFilter.emit();
    }
}
